<template>
  <Container type="card-full">
    <div v-loading="loading">
      <div>
        <div class="view-container">
          <div class="view-box">
            <!-- 确认邀请 -->
            <div v-if="+list.psutype === 2 && +listClone.psustatus === 1">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">邀请状态</div>
                  <div class="view-value">
                    <el-radio
                      v-for="(item, index) in psustatusList"
                      :key="index"
                      v-model="psustatus"
                      @change="changestatus"
                      :label="item.value"
                      >{{ item.label }}
                    </el-radio>
                  </div>
                </div>
              </div>
              <div v-if="+list.psutype === 2 && +isEdit === 3">
                <div class="view-row">
                  <div class="view-field">
                    <div class="view-label">
                      <span class="redstar">*</span>联系姓名
                    </div>
                    <div class="view-value">
                      <el-input
                        placeholder="请输入联系姓名"
                        v-model.trim="psucontactname"
                        clearable
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="view-row">
                  <div class="view-field">
                    <div class="view-label">
                      <span class="redstar">*</span>联系电话
                    </div>
                    <div class="view-value">
                      <el-input
                        placeholder="请输入联系电话"
                        v-model.trim="psucontactphone"
                        clearable
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="view-row">
                  <div class="view-field">
                    <div class="view-label">
                      <span class="redstar">*</span>联系邮箱
                    </div>
                    <div class="view-value">
                      <el-input
                        placeholder="请输入联系邮箱"
                        v-model.trim="psucontactmail"
                        clearable
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+isEdit === 4">
                <div class="view-field">
                  <div class="view-label">拒绝原因</div>
                  <div class="view-value">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2 }"
                      v-model="list.psubmcheckdesc"
                      :maxlength="255"
                      show-word-limit
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="qrInvite"
                      >提交</vxe-button
                    >
                  </div>
                </div>
              </div>
              <div class="split-line"></div>
            </div>
            <!-- 报名相关 -->
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">项目编号</div>
                <div class="view-value">{{ list.projectcode }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">平台编号</div>
                <div class="view-value">{{ list.projectno }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">报名方式</div>
                <div class="view-value">
                  {{ +list.projectisinvite === 1 ? "邀请" : "公开" }}
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">项目名称</div>
                <div class="view-content">{{ list.projectname }}</div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">采购人</div>
                <div class="view-value">{{ list.pcomfullname }}</div>
              </div>
            </div>
            <div class="view-row" v-if="+list.projectisinvite === 1">
              <div class="view-field">
                <div class="view-label">邀请人</div>
                <div class="view-value">{{ list.psubmcheckusername }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">邀请时间</div>
                <div class="view-value">{{ list.psubmchecktime }}</div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">经办人</div>
                <div class="view-value">{{ list.psuusername }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">报名时间</div>
                <div class="view-value">{{ list.psutime }}</div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">报名联系人</div>
                <div class="view-value">{{ list.psucontactname }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">报名电话</div>
                <div class="view-value">{{ list.psucontactphone }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">联系邮箱</div>
                <div class="view-value">{{ list.psucontactmail }}</div>
              </div>
            </div>
            <!-- <div class="view-row"  v-if="+list.psustatus !== 1 && +list.projectisinvite !== 1 &&+list.prsbmneedconfirm === 1">
              <div class="view-field">
                <div class="view-label">审核人</div>
                <div class="view-value">{{list.psubmcheckusername}}</div>
              </div>
              <div class="view-field">
                <div class="view-label">审核时间</div>
                <div class="view-value">{{list.psubmchecktime}}</div>
              </div>
            </div> -->
            <div class="view-row">
              <div class="view-field" style="align-items: center">
                <div class="view-label">状态</div>
                <div class="view-value">
                  <span>{{ statusname }}</span>
                  <el-button type="primary" icon="el-icon-message"  @click="auditLogListVisible = true" size="small" v-if="+list.prsbmneedconfirm === 1 && +list.projectisinvite !== 1" style="margin-left: 28px;">审核日志</el-button>
                </div>
                  
              </div>
              <div class="view-field" v-if="+listClone.psustatus === 2">
                <div class="view-label">驳回原因</div>
                <div class="view-value" style="color: red; font-weight: bold">
                  {{ list.psubmcheckdesc }}
                </div>
              </div>
              <div class="view-field" v-if="+listClone.psustatus === 4">
                <div class="view-label">拒绝原因</div>
                <div class="view-value" style="color: red; font-weight: bold">
                  {{ list.psubmcheckdesc }}
                </div>
              </div>
            </div>
            <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【报名费开票信息】请务必完善开票信息</div>
            </div>
            <!-- 单位名称，，信用代码，单位地址，开户银行，开户账号 -->
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">单位名称</div>
                <div class="view-value">{{ comlist.comfullname }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">信用代码</div>
                <div class="view-value">{{ comlist.comidcode }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">纳税人类型</div>
                <div class="view-value">
                  {{
                    +comlist.comtaxtype === 1
                      ? "一般纳税人"
                      : +comlist.comtaxtype === 2
                      ? "小规模纳税人"
                      : ""
                  }}
                </div>
              </div>
            </div>
            <div class="view-row">
              <div style="color: red">{{ cosInfo.cosfpxx }}</div>
            </div>
            <!-- </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">单位地址</div>
                <div class="view-value" v-if="+changeInfo===1">
                  {{comlist.comaddr}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.comaddr" placeholder="请输入单位地址" :maxlength="255" ></el-input>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">单位电话</div>
                <div class="view-value" v-if="+changeInfo===1">
                  {{comlist.comtel}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.comtel" placeholder="请输入单位电话" :maxlength="255" ></el-input>
                </div>
              </div>
            </div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">开户银行</div>
                <div class="view-value" v-if="+changeInfo===1">
                  {{comlist.combank}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.combank" placeholder="请输入开户银行" :maxlength="255"></el-input>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">开户账号</div>
                <div class="view-value" v-if="+changeInfo===1">
                  {{comlist.combanknumber}}
                </div>
                <div class="view-value" v-else>
                  <el-input v-model="comlist.combanknumber" placeholder="请输入开户账号" :maxlength="50"></el-input>
                </div>
              </div>
            </div> -->
            <!-- <div class="view-row">
              <div class="view-field">
                <div class="view-label" style="line-height:40px;">开票申请备注</div>
                <div class="view-con" v-if="+changeInfo===1" style="margin-top:10px;">
                  <div v-if="list.psuInvoicmark">{{list.psuInvoicmark}}</div>
                  <div v-else> 如：发票寄送地址与公司地址不一致，可填写收票地址（报名费只提供增值税普通发票电子票）</div>
                </div>
                <div class="view-con" v-else>
                    <el-input type="textarea" placeholder="如：发票寄送地址与公司地址不一致，可填写收票地址（报名费只提供增值税普通发票电子票）" :autosize="{ minRows: 2}"
                              v-model="list.psuInvoicmark" :maxlength="50" show-word-limit></el-input>
                </div>
              </div>
            </div> -->
            <!-- <div class="view-row" >
              <div class="view-field">
                <div class="view-label"></div>
                <div class="view-value">
                  <el-button type='primary' @click="savekpxx" v-if="+changeInfo!==1">保存</el-button>
                  <el-button type='primary' @click="changekhInfo" v-else>修改</el-button>
                </div>
              </div>
            </div> -->

            <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【报名费支付】</div>
            </div>
            <!-- 报名费相关 -->
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">报名费</div>
                <div class="view-Adaptive">
                  {{ setThousand(list.projectbmamt) }}元（
                  <amount
                    :money="String(list.projectbmamt)"
                    v-if="list.projectbmamt"
                  ></amount>
                  ）
                  <span
                    v-if="
                      Number(list.psubmpaytype) === 0 &&
                      +list.projectbmamt === 0
                    "
                    style="font-size: 12px; color: #f56c6c"
                    >免费</span
                  >
                </div>
              </div>
              <div
                class="view-field"
                v-if="
                  Number(list.psubmpaytype) !== 0 &&
                  +listClone.psubmpayflg !== 2
                "
              >
                <div class="view-label">支付方式</div>
                <div
                  class="view-value"
                  v-if="
                    Number(list.psubmpaytype) === 0 && +list.projectbmamt > 0
                  "
                >
                  暂未支付
                </div>
                <div class="view-value" v-else>
                  {{
                    Number(list.psubmpaytype) === 3
                      ? "线下支付"
                      : Number(list.psubmpaytype) === 1
                      ? "支付宝支付"
                      : "微信支付"
                  }}
                </div>
              </div>
            </div>
            <!--<el-form label-position="right" class="mainfrom">-->
            <!--<div class="from_label_big">-->
            <!--&lt;!&ndash; 报名费支付 &ndash;&gt;-->
            <!--<div-->
            <!--v-if="+listClone.psubmpaytype === 0 && +list.psustatus === 3  && +list.projectbmamt > 0 && +listClone.psubmpayflg !== 2">-->
            <!--<div class="row">-->
            <!--<el-form-item label="支付方式">-->
            <!--<el-radio-group v-model="bmradio" class="value" style="padding-top:11px" required>-->
            <!--<el-radio :label="1">线上支付</el-radio>-->
            <!--<el-radio :label="2">线下支付</el-radio>-->
            <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bmradio === 1">-->
            <!--<el-form-item label=" ">-->
            <!--<div class="btn">-->
            <!--<el-button @click="bmpay(1)">-->
            <!--<i class="el-icon-my-zfb"></i>-->
            <!--支付宝支付-->
            <!--</el-button>-->
            <!--<el-button @click="bmpay(2)">-->
            <!--<i class="el-icon-my-wechat"></i>-->
            <!--微信支付-->
            <!--</el-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bmradio === 2">-->
            <!--<el-form-item label="支付凭证" prop="psubmpayurl" verify>-->
            <!--<upload-pic-one @changed='setfilebm' :picUrl='list.psubmpayurl' folderName='web'-->
            <!--text="选择图片"></upload-pic-one>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bmradio === 2">-->
            <!--<el-form-item label=" "-->
            <!--v-if="+listClone.psubmpaytype === 0 && +list.psustatus === 3 && +list.projectbmamt > 0">-->
            <!--<vxe-button @click="savebm">保存</vxe-button>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash; 报名费重新支付 &ndash;&gt;-->
            <!--<div v-if="+list.psustatus === 3  && +list.projectbmamt > 0 && +listClone.psubmpayflg === 2">-->
            <!--<div class="row">-->
            <!--<el-form-item label="支付方式">-->
            <!--<el-radio-group v-model="bmradio" class="value" style="padding-top:11px" required>-->
            <!--<el-radio :label="1">线上支付</el-radio>-->
            <!--<el-radio :label="2">线下支付</el-radio>-->
            <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row">-->
            <!--<el-form-item label=" " v-if="+bmradio === 1">-->
            <!--<div class="btn">-->
            <!--<el-button @click="bmpay(1)" v-if="!list.psubmpaytradeno">-->
            <!--<i class="el-icon-my-zfb"></i>-->
            <!--支付宝支付-->
            <!--</el-button>-->
            <!--<el-button @click="bmpay(2)" v-if="!list.psubmpaytradeno">-->
            <!--<i class="el-icon-my-wechat"></i>-->
            <!--微信支付-->
            <!--</el-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row">-->
            <!--<div v-if="+bmradio === 2">-->
            <!--<el-form-item label="支付凭证" prop="psubmpayurl" verify>-->
            <!--<upload-pic-one @changed='setfilebm' :picUrl='list.psubmpayurl' folderName='web'-->
            <!--text="选择图片"></upload-pic-one>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bmradio === 2">-->
            <!--<el-form-item label=" ">-->
            <!--<div class="value"-->
            <!--v-if="+listClone.psubmpayflg === 2 && +list.psustatus === 3 && +list.projectbmamt > 0">-->
            <!--<vxe-button @click="resubmitbm">保存</vxe-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</el-form>-->
            <!--支付报名费-->
            <div
              v-if="
                +listClone.psubmpaytype === 0 &&
                +list.psustatus === 3 &&
                +list.projectbmamt > 0 &&
                +listClone.psubmpayflg !== 2
              "
            >
              <div class="view-row" v-if="+list.projectbmpayway === 3">
                <div class="view-field">
                  <div class="view-label">支付方式</div>
                  <div class="view-value">
                    <el-radio-group v-model="bmradio" class="value" required>
                      <el-radio :label="1">线上支付</el-radio>
                      <el-radio :label="2">线下支付</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 1">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-groupbtn">
                    <div>
                      <el-button @click="bmpay(1)" type="primary">
                        <i class="el-icon-my-zfb"></i>
                        支付宝支付
                      </el-button>
                    </div>
                    <div>
                      <el-button @click="bmpay(2)" type="primary">
                        <i class="el-icon-my-wechat"></i>
                        微信支付
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 2">
                <div class="view-field">
                  <div class="view-label">支付凭证</div>
                  <div class="view-value">
                    <upload-pic-one
                      @changed="setfilebm"
                      :picUrl="list.psubmpayurl"
                      folderName="web"
                      text="点击上传"
                    ></upload-pic-one>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 2">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="savebm">保存</vxe-button>
                  </div>
                </div>
              </div>
            </div>
            <!--报名费重新支付-->
            <div
              v-if="
                +list.psustatus === 3 &&
                +list.projectbmamt > 0 &&
                +listClone.psubmpayflg === 2
              "
            >
              <div class="view-row" v-if="+list.projectbmpayway === 3">
                <div class="view-field">
                  <div class="view-label">支付方式</div>
                  <div class="view-value">
                    <el-radio-group v-model="bmradio" class="value" required>
                      <el-radio :label="1">线上支付</el-radio>
                      <el-radio :label="2">线下支付</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 1">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-groupbtn">
                    <el-button
                      type="primary"
                      @click="bmpay(1)"
                      v-if="!list.psubmpaytradeno"
                    >
                      <i class="el-icon-my-zfb"></i>
                      支付宝支付
                    </el-button>
                    <el-button
                      type="primary"
                      @click="bmpay(2)"
                      v-if="!list.psubmpaytradeno"
                    >
                      <i class="el-icon-my-wechat"></i>
                      微信支付
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 2">
                <div class="view-field">
                  <div class="view-label">支付凭证</div>
                  <div class="view-value">
                    <upload-pic-one
                      @changed="setfilebm"
                      :picUrl="list.psubmpayurl"
                      folderName="web"
                      text="点击上传"
                    ></upload-pic-one>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bmradio === 2">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="resubmitbm"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="view-row" v-if="+listClone.psubmpayflg !== 2">
              <div class="view-field" v-if="Number(list.psubmpaytype) === 3">
                <div class="view-label">报名费凭证</div>
                <div class="view-content">
                  <popover-img
                    :img-src="
                      listClone.psubmpayurl
                        ? uploadAddr + listClone.psubmpayurl
                        : ''
                    "
                    default-height="150"
                  ></popover-img>
                </div>
              </div>
              <div
                class="view-field"
                v-else-if="
                  Number(list.psubmpaytype) === 2 ||
                  Number(list.psubmpaytype) === 1
                "
              >
                <div class="view-label">交易号</div>
                <div class="view-value">
                  {{ list.psubmpaytradeno }}
                </div>
              </div>
            </div>
            <div class="view-row" v-if="Number(list.psubmpaytype) !== 0">
              <div class="view-field">
                <div class="view-label">支付人</div>
                <div class="view-value">{{ list.psubmpayusername }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">支付时间</div>
                <div class="view-value">{{ list.psubmpaytime }}</div>
              </div>
            </div>
            <div class="view-row" v-if="Number(list.psubmpayflg) !== 0">
              <div class="view-field">
                <div class="view-label">审核状态</div>
                <div class="view-value" v-if="+list.projectbmamt === 0">
                  报名费为0，无需审核
                </div>
                <div class="view-value" v-if="+list.projectbmamt > 0">
                  {{
                    Number(list.psubmpayflg) === 0
                      ? "未审核"
                      : Number(list.psubmpayflg) === 1
                      ? "已收"
                      : "未收"
                  }}
                </div>
              </div>
              <!-- <div class="view-field">
                <div class="view-label">审核人</div>
                <div class="view-value">
                  <div v-if="+list.psubmpaytype === 1 || +list.psubmpaytype === 2">
                    线上支付
                  </div>
                  <div v-else>
                    {{list.psubmpaycheckusername}}
                  </div>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label">审核时间</div>
                <div class="view-value">{{list.psubmpaychecktime}}</div>
              </div> -->
            </div>
            <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【保证金支付】</div>
            </div>
            <!-- 保证金相关 -->
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">保证金</div>
                <div class="view-Adaptive">
                  {{ setThousand(list.projectbzjamt) }}元（
                  <amount :money="String(list.projectbzjamt)"></amount>
                  ）
                  <span
                    v-if="
                      Number(list.psubzjpaytype) === 0 &&
                      +list.projectbzjamt === 0
                    "
                    style="font-size: 12px; color: #f56c6c"
                    >免费</span
                  >
                </div>
              </div>
              <div class="view-field" v-if="Number(list.psubzjpaytype) !== 0">
                <div class="view-label">支付方式</div>
                <div
                  class="view-value"
                  v-if="
                    Number(list.psubzjpaytype) === 0 &&
                    +list.projectbzjamt === 0
                  "
                >
                  保证金为0，无需支付
                </div>
                <div
                  class="view-value"
                  v-else-if="
                    Number(list.psubzjpaytype) === 0 && +list.projectbzjamt > 0
                  "
                >
                  暂未支付
                </div>
                <div class="view-value" v-else>
                  {{
                    Number(list.psubzjpaytype) === 3
                      ? "线下支付"
                      : Number(list.psubzjpaytype) === 1
                      ? "支付宝支付"
                      : "微信支付"
                  }}
                </div>
              </div>
            </div>
            <!--<el-form label-position="right" class="mainfrom">-->
            <!--<div class="from_label_big">-->
            <!--&lt;!&ndash; 支付保证金 &ndash;&gt;-->
            <!--<div-->
            <!--v-if="+listClone.psubzjpaytype === 0 && +listClone.psubzjpayflg !== 2 && +list.psustatus === 3 && +list.projectbzjamt > 0">-->
            <!--<div class="row">-->
            <!--<el-form-item label="支付方式">-->
            <!--<el-radio-group v-model="bzjradio" style="padding-top:11px" required>-->
            <!--<el-radio :label="1">线上支付</el-radio>-->
            <!--<el-radio :label="2">线下支付</el-radio>-->
            <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 1">-->
            <!--<el-form-item label=" " v-if="+list.projectbzjamt > 0 && !list.psubzjpaytradeno">-->
            <!--<div class="btn">-->
            <!--<el-button @click="bzjpay(1)">-->
            <!--<i class="el-icon-my-zfb"></i>-->
            <!--支付宝支付-->
            <!--</el-button>-->
            <!--<el-button @click="bzjpay(2)">-->
            <!--<i class="el-icon-my-wechat"></i>-->
            <!--微信支付-->
            <!--</el-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 2">-->
            <!--<el-form-item label="支付凭证" prop="psubzjpayurl" verify>-->
            <!--<upload-pic-one @changed='setfilebzj' :picUrl='list.psubzjpayurl' folderName='web'-->
            <!--text="选择图片"></upload-pic-one>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 2">-->
            <!--<el-form-item label=" ">-->
            <!--<div class="value">-->
            <!--<vxe-button @click="savebzj">保存</vxe-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash; 重新支付保证金 &ndash;&gt;-->
            <!--<div v-if="+listClone.psubzjpayflg === 2 && +list.psustatus === 3 && +list.projectbzjamt > 0">-->
            <!--<div class="row">-->
            <!--<el-form-item label="支付方式">-->
            <!--<el-radio-group v-model="bzjradio" style="padding-top:11px" required>-->
            <!--<el-radio :label="1">线上支付</el-radio>-->
            <!--<el-radio :label="2">线下支付</el-radio>-->
            <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 1">-->
            <!--<el-form-item label=" ">-->
            <!--<div class="btn">-->
            <!--<el-button @click="bzjpay(1)">-->
            <!--<i class="el-icon-my-zfb"></i>-->
            <!--支付宝支付-->
            <!--</el-button>-->
            <!--<el-button @click="bzjpay(2)">-->
            <!--<i class="el-icon-my-wechat"></i>-->
            <!--微信支付-->
            <!--</el-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 2 ">-->
            <!--<el-form-item label="支付凭证" prop="psubzjpayurl" verify>-->
            <!--<upload-pic-one @changed='setfilebzj' :picUrl='list.psubzjpayurl' folderName='web'-->
            <!--text="选择图片"></upload-pic-one>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--<div class="row" v-if="+bzjradio === 2">-->
            <!--<el-form-item label=" ">-->
            <!--<div class="value">-->
            <!--<vxe-button @click="resubmitbzj">保存</vxe-button>-->
            <!--</div>-->
            <!--</el-form-item>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</el-form>-->
            <!-- 支付保证金 -->
            <div
              v-if="
                +listClone.psubzjpaytype === 0 &&
                +listClone.psubzjpayflg !== 2 &&
                +list.psustatus === 3 &&
                +list.projectbzjamt > 0 &&
                bmfIspay
              "
            >
              <div class="view-row" v-if="+list.projectbzjpayway === 3">
                <div class="view-field">
                  <div class="view-label">支付方式</div>
                  <div class="view-value">
                    <el-radio-group v-model="bzjradio" required>
                      <el-radio :label="1">线上支付</el-radio>
                      <el-radio :label="2">线下支付</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bzjradio === 1">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-groupbtn">
                    <el-button @click="bzjpay(1)" type="primary">
                      <i class="el-icon-my-zfb"></i>
                      支付宝支付
                    </el-button>
                    <el-button @click="bzjpay(2)" type="primary">
                      <i class="el-icon-my-wechat"></i>
                      微信支付
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bzjradio === 2">
                <div class="view-field">
                  <div class="view-label">支付凭证</div>
                  <div class="view-value">
                    <upload-pic-one
                      @changed="setfilebzj"
                      :picUrl="list.psubzjpayurl"
                      folderName="web"
                      text="点击上传"
                    ></upload-pic-one>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bzjradio === 2">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="savebzj"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 重新支付保证金 -->
            <div
              v-if="
                +listClone.psubzjpayflg === 2 &&
                +list.psustatus === 3 &&
                +list.projectbzjamt > 0
              "
            >
              <div class="view-row" v-if="+list.projectbzjpayway === 3">
                <div class="view-field">
                  <div class="view-label">支付方式</div>
                  <div class="view-value">
                    <el-radio-group v-model="bzjradio" required>
                      <el-radio :label="1">线上支付</el-radio>
                      <el-radio :label="2">线下支付</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <div class="view-row" v-if="+bzjradio === 1">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-groupbtn">
                    <el-button @click="bzjpay(1)">
                      <i class="el-icon-my-zfb"></i>
                      支付宝支付
                    </el-button>
                    <el-button @click="bzjpay(2)">
                      <i class="el-icon-my-wechat"></i>
                      微信支付
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">支付凭证</div>
                  <div class="view-value">
                    <upload-pic-one
                      @changed="setfilebzj"
                      :picUrl="list.psubzjpayurl"
                      folderName="web"
                      text="点击上传"
                    ></upload-pic-one>
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="resubmitbzj"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="view-row" v-if="+listClone.psubzjpayflg !== 2">
              <div class="view-field" v-if="Number(list.psubzjpaytype) === 3">
                <div class="view-label">保证金凭证</div>
                <div class="view-content">
                  <popover-img
                    :img-src="
                      listClone.psubzjpayurl
                        ? uploadAddr + listClone.psubzjpayurl
                        : ''
                    "
                    default-height="150"
                  ></popover-img>
                </div>
              </div>
              <div
                class="view-field"
                v-else-if="
                  Number(list.psubzjpaytype) === 2 ||
                  Number(list.psubzjpaytype) === 1
                "
              >
                <div class="view-label">交易号</div>
                <div class="view-value">{{ list.psubzjpaytradeno }}</div>
              </div>
            </div>
            <div class="view-row" v-if="Number(list.psubzjpaytype) !== 0">
              <div class="view-field">
                <div class="view-label">支付人</div>
                <div class="view-value">{{ list.psubzjpayusername }}</div>
              </div>
              <div class="view-field">
                <div class="view-label">支付时间</div>
                <div class="view-value">{{ list.psubzjpaytime }}</div>
              </div>
            </div>
            <div class="view-row" v-if="Number(list.psubzjpayflg) !== 0">
              <div class="view-field">
                <div class="view-label">审核状态</div>
                <div class="view-value" v-if="+list.projectbzjamt > 0">
                  {{
                    Number(list.psubzjpayflg) === 0
                      ? "未审核"
                      : Number(list.psubzjpayflg) === 1
                      ? "已收"
                      : "未收"
                  }}
                </div>
                <div class="view-value" v-else-if="+list.projectbzjamt === 0">
                  保证金为0，无需审核
                </div>
              </div>
              <!-- <div class="view-field">
                <div class="view-label">审核人</div>
                <div class="view-value">
                  <div v-if="+list.psubzjpaytype === 1 || +list.psubzjpaytype === 2">
                    线上支付
                  </div>
                  <div v-else>
                    {{list.psubzjpaycheckusername}}
                  </div>
                </div>
              </div>
              <div class="view-field">
                <div class="view-label">审核时间</div>
                <div class="view-value">{{list.psubzjpaychecktime}}</div>
              </div> -->
            </div>

            <!-- 保证金退回 -->
            <div v-if="+listClone.psubzjreturnflg === 1">
              <div class="split-line"></div>
              <div class="view-row">
                <div class="view-field" v-if="listClone.psubzjreturnurl">
                  <div class="view-label">保证金退回凭证</div>
                  <div class="view-value">
                    <popover-img
                      :img-src="
                        listClone.psubzjreturnurl
                          ? uploadAddr + listClone.psubzjreturnurl
                          : ''
                      "
                      default-height="150"
                    ></popover-img>
                  </div>
                </div>
                <div class="view-field" v-if="listClone.psubzjreturntradeno">
                  <div class="view-label">交易号</div>
                  <div class="view-value">
                    {{ listClone.psubzjreturntradeno }}
                  </div>
                </div>
                <div class="view-field">
                  <div class="view-label">是否退回</div>
                  <div class="view-value">
                    {{ +listClone.psubzjreturnflg === 1 ? "已退回" : "未退回" }}
                  </div>
                </div>
              </div>
              <!-- <div class="view-row">
                <div class="view-field">
                  <div class="view-label">退回人</div>
                  <div class="view-value">{{listClone.psubzjreturnusername}}</div>
                </div>
                <div class="view-field">
                  <div class="view-label">退回时间</div>
                  <div class="view-value">{{listClone.psubzjreturntime}}</div>
                </div>
              </div> -->
            </div>

            <div v-if="+listClone.projectisinvite !== 1 && +listClone.prsbmneedconfirm === 1">
              <div class="split-line"></div>
              <!--报名附件-->
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">报名文件</div>
                  <div>
                    <div
                      v-if="
                        +listClone.psustatus === 2 || +listClone.psustatus === 1
                      "
                    > 
                      <div v-show="uploadBtnDisabled" style="font-size: 14px;color: red;font-weight:bold;margin-bottom:4px">
                        {{afterbmTimeDesc}}
                      </div>
                      <upload-btn
                        @changed="setfilebmfj"
                        :disabled="uploadBtnDisabled"
                        text="上传报名文件"
                        :beforeUpload="beforeUpload"
                      ></upload-btn>
                    </div>
                    <div v-if="appendList.length">
                      <div class="view-filelist">
                        <div
                          v-for="(item, index) in appendList"
                          :key="index"
                          class="view-fileitem"
                        >
                          <div
                            class="view-filename"
                            @click="downFile(item.appendurl)"
                          >
                            <a :src="uploadAddr + item.appendurl">{{
                              item.appendfilename
                            }}</a>
                          </div>
                          <!---->
                          <div
                            v-if="
                              (+listClone.psustatus === 2 ||
                              +listClone.psustatus === 1) &&
                              !uploadBtnDisabled
                            "
                            class="view-filebtn"
                            @click="delappend(item)"
                          >
                            <span>删除</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--<div v-else>无</div>-->
                  </div>
                </div>
              </div>
              <div
                class="view-row"
                v-if="
                  (+listClone.psustatus === 2 || +listClone.psustatus === 1) &&
                  appendList.length
                "
              >
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button type="primary" @click="savebmfj" :disabled="uploadBtnDisabled"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="split-box" v-if="list.projectbmamt > 0">
              <div class="split-line"></div>
              <div class="split-name">【报名费发票】</div>
            </div>
            <div class="view-row" v-if="list.projectbmamt > 0">
              <div class="view-field">
                <div class="view-label">开票</div>
                <div class="view-value">
                  {{ +list.psubminvoiceflg === 2 ? "已开" : "未开" }}
                </div>
              </div>
              <div class="view-field" v-if="+list.psubminvoiceflg === 2">
                <div class="view-label">发票号</div>
                <div class="view-value">{{ list.psubminvoicenum }}</div>
              </div>
              <div class="view-field" v-if="+list.psubminvoiceflg === 2">
                <div class="view-label">开票时间</div>
                <div class="view-value">
                  {{ list.psubminvoicetime | newDate }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="split-line" v-if="listClone.psubzjreturntradeno"></div>
      </div>

      <div>
        <!--<el-form label-position="right" class="mainfrom">-->
        <!--<el-form-item label="报名附件">-->
        <!--<div class="file">-->
        <!--<upload-btn @changed='setfilebmfj' text="上传报名文件"-->
        <!--v-if="+listClone.psustatus === 2 || +listClone.psustatus === 1"></upload-btn>-->
        <!--<div v-if="appendList.length" class="filelist">-->
        <!--<div v-for="(item,index) in appendList" :key="index" class="fileitem">-->
        <!--<div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>-->
        <!--</div>-->
        <!--<div class="btn" @click="delappend(item)"-->
        <!--v-if="+listClone.psustatus === 2 || +listClone.psustatus === 1"><span>删除</span></div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--<vxe-button v-if="+listClone.psustatus === 2 || +listClone.psustatus === 1" @click="savebmfj">保存-->
        <!--</vxe-button>-->
        <!--</el-form-item>-->
        <!--</el-form>-->
      </div>
      <paycommon
        :type="Paytype"
        :visible="visible"
        :order="order"
        @cacle="cacle"
      >
        <div class="wxmessage">
          <div class="wxmessageItem">
            <div class="itemName">交易金额</div>
            <div class="itemPrice">
              <span class="priceText">{{ payamt }}</span
              >元
            </div>
          </div>
          <div class="wxmessageItem">
            <div class="itemName">支付方式</div>
            <div class="itemPrice">微信支付</div>
          </div>
          <div class="wxmessageItem">
            <div class="itemName">交易号</div>
            <div class="itemPrice">{{ order.outTradeNo }}</div>
          </div>
        </div>
      </paycommon>
    </div>
    <el-dialog title="审核日志" @open="auditDialogOpen" :loading="auditDialogLoading" :visible.sync="auditLogListVisible" width="50%">
      <audit-log-list :auditLogList="auditLogList"></audit-log-list>
    </el-dialog>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import config from "../../assets/config";
import uploadPicOne from "../common/uploadPicOne";
import uploadBtn from "../common/uploadBtn";
import amount from "../common/amount";
import popoverImg from "../common/popoverImg";
import paycommon from "../../components/core/paycommon";
import common from "@/mixin/common";
import dayjs from "dayjs";
import _ from "lodash";
import auditLogList from "./auditLogList.vue";

export default {
  name: "psucgForm",
  data() {
    return {
      auditDialogLoading: false,
      auditLogListVisible: false,
      auditLogList: [],
      userid: this.$store.getters.loginUser.userid,
      projectid: this.$route.params.form.psuprojectid,
      psuid: this.$route.params.form.psuid,
      btnLoading: false,
      psustatusList: [],
      appendList: [],
      appendbmfjList: [],
      project: {},
      list: [],
      isEdit: 0, //拒绝邀请时候的输入框显示
      bmradio: 1, //线上线下支付的选项
      psustatus: "",
      bzjradio: 1,
      order: {
        outTradeNo: "", //订单号
        productCode: "FAST_INSTANT_TRADE_PAY",
        totalAmount: "", //金额：微信单位（分），支付宝单位（元）
        subject: "", //商品名
        body: "", //商品信息
        passback_params: "", //项目id_用户id_保证金0或者服务费1
      },
      listClone: [],
      visible: false,
      payamt: 999999,
      Paytype: 0,
      loading: false,
      Interval: null,
      psucontactname: "",
      psucontactphone: "",
      psucontactmail: "",
      changeInfo: 1,
      comlist: [],
      cosInfo: {},
      isFirstUploadFile: true // 是否之前没有上传报名文件
    };
  },
  created() {
  },
  async activated() {
    this.init();
    this.getcosInfo();
    this.getAppends();
    this.getPsustatusList();
    this.getProject();
    this.getComInfo();
  },
  mixins: [common],
  async mounted() {},
  watch: {},
  filters: {
    newDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  components: { uploadBtn, uploadPicOne, paycommon, popoverImg, amount, auditLogList },
  computed: {
    invalidStatus () {
      if (+this.list.prsbmneedconfirm === 1) {
        return +this.list.psustatus === 1 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime))
      } else {
        return false
      }
      
    },
    uploadBtnDisabled () {
      // 需要审核的情况下
      if (+this.list.prsbmneedconfirm === 1) {
        // 项目规定报名截止时间 增加2小时
        const afterbmtime = dayjs(this.list.prsbmendtime).add(2, 'hour')
        // 驳回状态 没有上传过文件 并且系统时间大于报名截止时间
        if (+this.list.psustatus === 2 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
          return true
        }
        //  驳回状态 不是第一次上传文件 并且系统时间大于报名截止时间
        if (+this.list.psustatus === 2 && !this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
          return true
        }
        // 待审状态 第一次上传文件 , 已经超时
        else if (+this.list.psustatus === 1 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime))) {
          return true
        } else {
          return false
        }
      }
       else {
        return false
      }
     
    },
    afterbmTimeDesc () {
      // 项目规定报名截止时间 增加2小时
      const afterbmtime = dayjs(this.list.prsbmendtime).add(2, 'hour')
      if (+this.list.psustatus === 2 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
         return `提醒：驳回的报名，应在本项目报名截止时间${this.formatTime(this.list.prsbmendtime)}后2个小时内重新上传，超时不允许上传报名文件。`
      }
      else if (+this.list.psustatus === 2 && !this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
        return `提醒：驳回的报名，应在本项目报名截止时间${this.formatTime(this.list.prsbmendtime)}后2个小时内重新上传，超时不允许上传报名文件。`
      }
      // 第一次上传文件 并且系统时间大于报名截止时间
      else if (+this.list.psustatus === 1 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime))) {
        return `提醒：本项目报名及提交报名文件截止时间为${this.formatTime(this.list.prsbmendtime)}，超时不允许上传报名文件。`
      } else {
        return ''
      }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    statusname() {
      if (+this.list.prsbmneedconfirm === 1 && +this.list.psustatus === 1 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime))) {
        return '无效'
      }
      else {
        if (+this.list.psustatus === 1) {
          return '待审'
        } else if (+this.list.psustatus === 2) {
          return '驳回'
        } else if (+this.list.psustatus === 3) {
          return '通过'
        } else if (+this.list.psustatus === 4) {
          return '拒绝'
        }  
      }
    },
    bmfIspay() {
      if (+this.list.projectbmamt === 0) {
        return true;
      } else {
        if (+this.listClone.psubmpayflg === 1) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  methods: {
    async getAuditLogList() {
      this.auditDialogLoading = true
      return request({
        url: '/auditlog/getAuditLog',
        method: 'get',
        params: {
          auditlogfromid: this.list.psuid,
          auditlogcosid: this.$store.getters.loginUser.cosid,
          auditlogcode: 10
        }
      })
    },
    async auditDialogOpen () {
      this.auditDialogLoading = false
      const data = await this.getAuditLogList()
      this.auditLogList = data
    },
    beforeUpload () {
      if (+this.list.prsbmneedconfirm === 1) { 
        const afterbmtime = dayjs(this.list.prsbmendtime).add(2, 'hour')
        if (+this.list.psustatus === 2 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
          this.$message.warning(`提醒：驳回的报名，应在本项目报名截止时间${this.formatTime(this.list.prsbmendtime)}后2个小时内重新上传，超时不允许上传报名文件。`)
          this.getProject();
          return false
        }
        if (+this.list.psustatus === 2 && !this.isFirstUploadFile &&  dayjs().isAfter(dayjs(this.list.prsbmendtime)) && dayjs().isAfter(afterbmtime)) {
          this.$message.warning(`提醒：驳回的报名，应在本项目报名截止时间${this.formatTime(this.list.prsbmendtime)}后2个小时内重新上传，超时不允许上传报名文件。`)
          this.getProject();
          return false
        }
        // 第一次上传文件 并且系统时间大于报名截止时间
        else if (+this.list.psustatus === 1 && this.isFirstUploadFile && dayjs().isAfter(dayjs(this.list.prsbmendtime))) {
          this.$message.warning(`提醒：本项目报名及提交报名文件截止时间为${this.formatTime(this.list.prsbmendtime)}，超时不允许上传报名文件。`)
          this.getProject();
          return false
        } 
         else {
          return true
        }
      }
      else {
        return true
      }

    },
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    setThousand(value) {
      return utils.comdify(value);
    },
    changekhInfo() {
      this.changeInfo = 2;
    },
    async savekpxx() {
      if (!this.comlist.comaddr === "") {
        this.$message.warning("单位地址不能为空！");
        return;
      }
      if (!this.comlist.combank === "") {
        this.$message.warning("开户银行不能为空！");
        return;
      }
      if (this.comlist.combanknumber === "") {
        this.$message.warning("银行账号不能为空！");
        return;
      }
      let from = {};
      from.psuid = this.list.psuid;
      from.psuInvoicmark = this.list.psuInvoicmark;
      from.comtel = this.comlist.comtel;
      from.comaddr = this.comlist.comaddr;
      from.combank = this.comlist.combank;
      from.combanknumber = this.comlist.combanknumber;
      from.comid = this.comlist.comid;
      let data = await request({
        url: "/xmgl/project/updatecom",
        method: "post",
        data: from,
      });
      if (data.issuccess === 1) {
        this.getProject();
        this.changeInfo = 1;
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败");
      }
    },
    async init() {
      (this.userid = this.$store.getters.loginUser.userid),
        (this.projectid = this.$route.params.form.psuprojectid),
        (this.psuid = this.$route.params.form.psuid),
        (this.btnLoading = false),
        (this.psustatusList = []),
        (this.appendList = []),
        (this.payamt = 999999),
        (this.project = {}),
        (this.list = []),
        (this.isEdit = 0), //拒绝邀请时候的输入框显示
        (this.psustatus = 0);
      // this.bmradio=1,  //线上线下支付的选项
      // this.bzjradio=1,
      (this.order = {
        outTradeNo: "", //订单号
        productCode: "FAST_INSTANT_TRADE_PAY",
        totalAmount: "", //金额：微信单位（分），支付宝单位（元）
        subject: "", //商品名
        body: "", //商品信息
        passback_params: "", //项目id_用户id_保证金0或者服务费1
      }),
        (this.listClone = []),
        (this.visible = false),
        (this.Paytype = 0),
        (this.Interval = null);
    },
    cacle(val) {
      //关闭窗口
      this.visible = val;
      clearInterval(this.Interval);
    },
    async getProject() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getpsubyid",
        params: { psuid: this.psuid },
      });
      res[0].psutime = utils.formatterDate(
        res[0].psutime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubmchecktime = utils.formatterDate(
        res[0].psubmchecktime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubmpaytime = utils.formatterDate(
        res[0].psubmpaytime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubmpaychecktime = utils.formatterDate(
        res[0].psubmpaychecktime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubzjpaytime = utils.formatterDate(
        res[0].psubzjpaytime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubzjpaychecktime = utils.formatterDate(
        res[0].psubzjpaychecktime,
        "yyyy-MM-dd HH:mm:ss"
      );
      res[0].psubzjreturntime = utils.formatterDate(
        res[0].psubzjreturntime,
        "yyyy-MM-dd HH:mm:ss"
      );

      if (+res[0].psubmpaytype === 3) {
        this.bmradio = 2;
      } else {
        this.bmradio = 1;
      }
      if (+res[0].psubzjpaytype === 3) {
        this.bzjradio = 2;
      } else {
        this.bzjradio = 1;
      }
      if (+res[0].projectbmpayway === 1) {
        this.bmradio = 1;
      } else if (+res[0].projectbmpayway === 2) {
        this.bmradio = 2;
      }
      if (+res[0].projectbzjpayway === 1) {
        this.bzjradio = 1;
      } else if (+res[0].projectbzjpayway === 2) {
        this.bzjradio = 2;
      }
      this.list = res[0]; //储存当前数据

      this.listClone = _.cloneDeep(this.list); //深拷贝一个对象。防止当前操作改变页面状态
      this.loading = false;
    },
    async getuserinfo() {
      let res = await request({
        method: "get",
        url: "/xtgl/user/getUser",
        params: { userid: this.$store.getters.loginUser.userid },
      });
      this.psucontactname = res[0].username;
      this.psucontactphone = res[0].usercode;
      this.psucontactmail = res[0].useremail;
    },
    changestatus(e) {
      this.list.psubmcheckdesc = "";
      this.isEdit = e;
      if (+e === 3) {
        this.getuserinfo();
      }
    },
    async getcosInfo() {
      let res = await request({
        method: "get",
        url: "/ywgl/cos/getCosbyid",
        params: { cosid: this.$store.state.user.loginUser.cosid },
      });
      this.cosInfo = res[0];
    },
    async getPsustatusList() {
      this.psustatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "psustatus" },
      });
      this.psustatusList.splice(0, 1);
      this.psustatusList.splice(1, 1);
    },
    async qrInvite() {
      //确认邀请
      if (!this.psustatus) {
        this.$message.warning("请选择邀请状态！");
        return;
      }
      if (+this.psustatus === 4 && this.list.psubmcheckdesc === "") {
        this.$message.warning("请先填写拒绝原因！");
        return;
      }
      if (+this.isEdit === 3 && !this.psucontactname) {
        this.$message.warning("请先填写报名联系人！");
        return;
      }
      if (+this.isEdit === 3 && !this.psucontactphone) {
        this.$message.warning("请先填写联系人电话！");
        return;
      }
      if (+this.isEdit === 3 && !this.psucontactmail) {
        this.$message.warning("请先填写联系人邮箱！");
        return;
      }
      let form = {};
      form.psustatus = this.psustatus;
      form.psuuserid = this.$store.getters.loginUser.userid;
      form.psuid = this.$route.params.form.psuid;
      form.psubmcheckdesc = this.list.psubmcheckdesc
        ? this.list.psubmcheckdesc
        : null;
      form.psucontactname = this.psucontactname;
      form.psucontactphone = this.psucontactphone;
      form.psucontactmail = this.psucontactmail;
      form.appends = this.appendList;
      let res = await request({
        url: "/xmgl/project/confirminvite",
        method: "post",
        data: form,
      });
      if (res.issuccess === 1) {
        this.$message.success("提交成功");
        this.getProject();
        return;
      }
    },
    async setfilebm(path) {
      this.list.psubmpayurl = path.replace(this.uploadAddr, "");
    },
    async setfilebzj(path) {
      this.list.psubzjpayurl = path.replace(this.uploadAddr, "");
    },
    async bmpay(type) {
      //报名费支付宝支付
      let num = 1; //微信支付为100
      // if(this.list.psubmpaytradeno){
      //   this.$message.warning('已支付')
      //   return
      // }
      // if(this.list.psubmpayurl){
      //   this.$message.warning('凭证已上传')
      //   return
      // }
      if (type === 2) {
        num = 100;
      }
      let payflg = true;
      //psuid_项目id_用户id_报名费0保证金1或者服务费2///this.project.projectno
      let passback_params =
        this.$route.params.form.psuid +
        "_" +
        this.list.psuprojectid +
        "_" +
        this.userid +
        "_" +
        0 +
        "_" +
        this.$store.state.user.loginUser.cosid;
      this.Paytype = type;
      this.payamt = this.list.projectbmamt;
      this.order.outTradeNo =
        this.list.projectno +
        "001" +
        this.userid +
        parseInt(Math.random() * (100 + 1), 10);
      this.order.subject = this.list.projectname;
      this.order.totalAmount = this.list.projectbmamt * num;
      this.order.passback_params = passback_params;
      this.order.body = this.list.projectname;
      this.order.cosmerchantNumber =
        this.$store.state.user.loginUser.cosmerchantNumber;
      this.order.coswxPublicAccountId =
        this.$store.state.user.loginUser.coswxPublicAccountId;
      this.order.coswxPublicKey =
        this.$store.state.user.loginUser.coswxPublicKey;
      this.order.coswxSecurityPrivateKey =
        this.$store.state.user.loginUser.coswxSecurityPrivateKey;
      this.order.cosalipayApplicationId =
        this.$store.state.user.loginUser.cosalipayApplicationId;
      this.order.cosalipayPublicKey =
        this.$store.state.user.loginUser.cosalipayPublicKey;
      this.order.cosalipayPrivateKey =
        this.$store.state.user.loginUser.cosalipayPrivateKey;
      this.visible = true;
      this.Interval = setInterval(async () => {
        let data = await request({
          url: "/xmgl/project/searchPay",
          method: "get",
          params: { psuid: this.$route.params.form.psuid },
        });
        if (data[0].psubmpaytradeno) {
          this.cacle(false);
          this.getProject();
          if (payflg === true) {
            this.$message.success("支付成功");
            this.wxpush(1);
          }
          payflg = false;
          return;
        }
      }, 500);
    },
    async bzjpay(type) {
      //保证金支付
      let num = 1; //微信支付为100
      // if(this.list.psubzjpaytradeno){
      //   this.$message.warning('已支付')
      //   return
      // }
      // if(this.list.psubzjpayurl){
      //   this.$message.warning('凭证已上传')
      //   return
      // }
      if (type === 2) {
        num = 100;
      }
      let payflg = true;
      //psuid_项目id_用户id_报名费0\保证金1\服务费2///this.project.projectno
      let passback_params =
        this.list.psuid +
        "_" +
        this.list.psuprojectid +
        "_" +
        this.userid +
        "_" +
        1 +
        "_" +
        this.$store.state.user.loginUser.cosid;
      this.Paytype = type;
      this.payamt = this.list.projectbzjamt;
      this.order.outTradeNo =
        this.list.projectno +
        "002" +
        this.userid +
        parseInt(Math.random() * (100 + 1), 10);
      this.order.subject = this.list.projectname;
      this.order.totalAmount = this.list.projectbzjamt * num;
      this.order.passback_params = passback_params;
      this.order.cosmerchantNumber =
        this.$store.state.user.loginUser.cosmerchantNumber;
      this.order.coswxPublicAccountId =
        this.$store.state.user.loginUser.coswxPublicAccountId;
      this.order.coswxPublicKey =
        this.$store.state.user.loginUser.coswxPublicKey;
      this.order.coswxSecurityPrivateKey =
        this.$store.state.user.loginUser.coswxSecurityPrivateKey;
      this.order.cosalipayApplicationId =
        this.$store.state.user.loginUser.cosalipayApplicationId;
      this.order.cosalipayPublicKey =
        this.$store.state.user.loginUser.cosalipayPublicKey;
      this.order.cosalipayPrivateKey =
        this.$store.state.user.loginUser.cosalipayPrivateKey;
      this.visible = true;
      this.order.body = this.list.projectname;
      this.Interval = setInterval(async () => {
        let data = await request({
          url: "/xmgl/project/searchPay",
          method: "get",
          params: { psuid: this.psuid },
        });
        if (data[0].psubzjpaytradeno) {
          this.cacle(false);
          this.getProject();
          if (payflg === true) {
            this.$message.success("支付成功");
            this.wxpush(2);
          }
          payflg = false;
          return;
        }
      }, 500);
    },
    async resubmitbm() {
      //重新提交报名费
      this.list.psubmpayuserid = this.userid;
      this.list.psubmpaytype = 3;
      this.list.psubmpayflg = 0;
      this.list.psubmpaycheckuserid = null;
      let data = await request({
        url: "/xmgl/project/savePsuBmPay",
        method: "post",
        data: this.list,
      });
      if (data.issuccess === 1) {
        this.getProject();
        this.wxpush(1);
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败");
      }
    },
    async savebm() {
      //报名费线下支付
      // if(+this.list.psubmpaytype !== 0){
      //   this.$message.warning('已支付')
      //   return
      // }
      if (+this.list.projectbmamt > 0 && !this.list.psubmpayurl) {
        this.$message.warning("请上传支付凭证！");
        return;
      }
      this.list.psubmpayuserid = this.userid;
      this.list.psubmpaytype = 3;
      let data = await request({
        url: "/xmgl/project/savePsuBmPay",
        method: "post",
        data: this.list,
      });
      if (data.issuccess === 1) {
        this.getProject();
        this.wxpush(1);
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败");
      }
    },
    async wxpush(type) {
      let model = {};
      model.userid = this.list.projectcuserid;
      model.cosid = this.$store.getters.loginUser.cosid;
      model.payTStype = type;
      model.psuid = this.list.psuid;
      model.projectid = this.list.projectid;
      await request({
        url: "/info/rush/reminders",
        method: "get",
        params: model,
      });
    },
    async regNotice() {
      let model = {};
      model.psuid = this.list.psuid;
      model.projectid = this.list.projectid;
      model.cosid = this.$store.getters.loginUser.cosid;
      model.psuuserid = this.list.psuuserid;
      await request({
        url: "/info/rush/resubmitBM",
        method: "post",
        data: model,
      });
    },
    //获取供应商单位信息
    async getComInfo() {
      let from = {};
      from.comid = this.$store.getters.loginUser.comid;
      from.cosid = this.$store.getters.loginUser.cosid;
      let data = await request({
        url: "/ywgl/com/getComById",
        method: "get",
        params: from,
      });
      this.comlist = data[0];
    },
    async savebzj() {
      //保证金线下支付
      // if(+this.list.psubzjpaytype !== 0){
      //   this.$message.warning('已支付')
      //   return
      // }
      if (+this.list.projectbzjamt > 0 && !this.list.psubzjpayurl) {
        this.$message.warning("请上传支付凭证！");
        return;
      }
      this.list.psubzjpayuserid = this.userid;
      this.list.psubzjpaytype = 3;
      this.list.cosid = this.$store.state.user.loginUser.cosid;
      let data = await request({
        url: "/xmgl/project/savePsuBzjPay",
        method: "post",
        data: this.list,
      });
      if (data.issuccess === 1) {
        await this.getProject();
        await this.wxpush(2);
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败");
      }
    },
    async resubmitbzj() {
      //重新提交保证金
      this.list.psubzjpayuserid = this.userid;
      this.list.psubzjpaytype = 3;
      this.list.psubzjpayflg = 0;
      this.list.cosid = this.$store.state.user.loginUser.cosid;
      let data = await request({
        url: "/xmgl/project/savePsuBzjPay",
        method: "post",
        data: this.list,
      });
      if (data.issuccess === 1) {
        this.getProject();
        this.wxpush(2);
        this.$message.success("保存成功");
      } else {
        this.$message.error("保存失败");
      }
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "psuFrom",
      });
    },
    async getAppends() {
      // console.log(this.psu, 88888)
      this.appendList = await request({
        method: "get",
        url: "/ywgl/append/getAppendListByFromId",
        params: { appendfromid: this.psuid, appendfromtype: 10 },
      });
      if (this.appendList.length > 0) {
        this.isFirstUploadFile = false
      }
    },
    async setfile(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: this.$route.params.form.psuid,
        appendfromtype: 10,
        appendtype: 100,
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList.push(append);
    },
    async setfilebmfj(path, filename) {
      let append = {
        appendid: 0,
        appendfromid: this.psuid,
        appendfromtype: 10,
        appendtype: 100,
        appendseq: this.appendList.length + 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appendList.push(append);
    },
    async savebmfj() {
      if (this.beforeUpload()) {
        let data = await request({
        url: "/xmgl/project/reupload",
        method: "post",
        data: { psuid: this.psuid, appends: this.appendList, psustatus: 1, auditloguserid:  this.userid, auditlogcosid:  this.$store.state.user.loginUser.cosid},
      });
      if (data.issuccess === 1) {
        this.$message.success("报名文件上传成功");
        this.regNotice();
        // this.getProject()
        this.close();
      } else {
        this.$message.error("报名文件上传失败");
      }
      }
      
    },
    delappend(file) {
      this.$confirm(`确定移除 ${file.appendfilename}？`, "提示", {
        type: "warning",
      })
        .then(() => {
          let index = this.appendList.findIndex(
            (val) => val.appendfilename === file.appendfilename
          );
          this.appendList.splice(index, 1);
        })
        .catch(() => {});
    },
  },
  destroyed() {
    clearInterval(this.Interval);
  },
};
</script>

<style lang="scss" scoped>
/*@import "../../styles/filelist";*/

.el-icon-my-wechat {
  background-image: url("../../assets/image/wechat.png");
  background-size: cover;
}

.el-icon-my-wechat:before {
  content: "替";
  font-size: 20px;
  visibility: hidden;
}

.el-icon-my-zfb {
  background-image: url("../../assets/image/zfb.png");
  background-size: cover;
}

.el-icon-my-zfb:before {
  content: "替";
  font-size: 20px;
  visibility: hidden;
}

.mainfrom {
  padding-top: 20px;
  .value {
    width: 300px;
  }
  .content {
    width: 400px;
  }
  .file {
    display: flex;
    flex-direction: column;
    width: 50%;
    .uploadbtn {
      display: flex;
      span {
        padding-left: 10px;
        color: red;
      }
    }
  }
}

.wxmessage {
  margin-top: 20px;
  border: 1px solid #c8c8c8;
  width: 100%;
  font: 12px/1.5 tahoma, arial, 宋体;
}

.wxmessageItem {
  display: flex;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #c8c8c8;
}

.wxmessageItem:nth-child(3) {
  border-bottom: none;
}

.itemName {
  width: 100px;
  flex: 0 0 100px;
  background-color: #fbfbfb;
  border-right: 1px solid #c8c8c8;
  text-align: right;
  padding: 5px;
}

.itemPrice {
  width: 650px;
  flex: 0 0 650px;
  padding: 5px;
}

.priceText {
  font-size: 22px;
  color: #f60;
  font-weight: bold;
}
.split-box {
  margin: 11px 0 15px;
  .split-line {
    margin: 5px;
  }
  .split-name {
    font-weight: bold;
  }
}
</style>
